<hs-no-loaded-account [content]="selectedExtTransactionId">
</hs-no-loaded-account>

<ng-template #selectedExtTransactionId>
  <security-mapping-ui
    [transactionid]="transactionid"
    [positionid]="positionid"
    [positioncusip]="positioncusip"
    [source]="source"
    [userid]="userid"
    [accountid]="accountid"
    (jobEvent$)="focusJobEvent($event)"
  ></security-mapping-ui>
</ng-template>
